import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang, nav2 } = this.props
    return (
      <div className="prize">
        {nav2 == 1 && 
          <div className='world-prize-box'>
              <div className='prize-box '>
                <span>NO.1</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/hello_world_no1.png" alt="" />
                    </div>
                    <p>Medal(Gold*1 year</p>
                  </div>


                  <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/noble/king.png" alt="" />
                    </div>
                    <p>VIP5 30days</p>
                  </div>

                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/hello_world_no1.png" alt="" />
                    </div>
                    <p>Headwear*30 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/hello_world_no1.png" alt="" />
                    </div>
                    <p>mount 30days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>7% of score</p>
                  </div>
                  </div>
              </div>

              <div className='prize-box'>
                <span>NO.2</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/hello_world_no2.png" alt="" />
                    </div>
                    <p>Medal(Silver*1 year</p>
                  </div>

                  <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/noble/duke.png" alt="" />
                    </div>
                    <p>VIP4 30days</p>
                  </div>

                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/hello_world_no2.png" alt="" />
                    </div>
                    <p>Headwear*15 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/hello_world_no2.png" alt="" />
                    </div>
                    <p>mount 15days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>5% of score</p>
                  </div>
                  </div>
              </div>


              <div className='prize-box'>
                <span>NO.3</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/hello_world_no3.png" alt="" />
                    </div>
                    <p>Medal(Copper*1 year</p>
                  </div>
                  
                  <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/noble/marquis.png" alt="" />
                    </div>
                    <p>VIP3 30days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/hello_world_no3.png" alt="" />
                    </div>
                    <p>Headwear*7 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/hello_world_no3.png" alt="" />
                    </div>
                    <p>mount 7days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>3% of score</p>
                  </div>
                  </div>
              </div>

              <div className='prize-box room'>
                  <span>Room Medal</span>
                  <div className="reward-list">
                    <div className="item-gift">
                        <div>
                          <img src="https://img.chatie.live/app/medal/images/KSA_room_badges_top1.png" alt="" />
                        </div>
                        <p>No.1 Medal* 1 year</p>
                    </div>

                    <div className="item-gift">
                        <div>
                          <img src="https://img.chatie.live/app/medal/images/KSA_room_badges_top2.png" alt="" />
                        </div>
                        <p>No.2 Medal* 1 year</p>
                    </div>

                    <div className="item-gift">
                        <div>
                          <img src="https://img.chatie.live/app/medal/images/KSA_room_badges_top3.png" alt="" />
                        </div>
                        <p>No.3 Medal* 1 year</p>
                    </div>
                  </div>

              </div>
          </div>
        }

{nav2 == 2 && 
          <div>
              <div className='prize-box'>
                <span>NO.1</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/ksa_no1.png" alt="" />
                    </div>
                    <p>Medal(Gold*1 year</p>
                  </div>

                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/ksa_no1.png" alt="" />
                    </div>
                    <p>Headwear*30 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/ksa_no1.png" alt="" />
                    </div>
                    <p>mount 30days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>7% of score</p>
                  </div>
                  </div>
              </div>

              <div className='prize-box'>
                <span>NO.2</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/ksa_no2.png" alt="" />
                    </div>
                    <p>Medal(Silver*1 year</p>
                  </div>

                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/ksa_no2.png" alt="" />
                    </div>
                    <p>Headwear*15 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/ksa_no2.png" alt="" />
                    </div>
                    <p>mount 15days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>5% of score</p>
                  </div>
                  </div>
              </div>


              <div className='prize-box'>
                <span>NO.3</span>
                <div className="reward-list">
                <div className="item-gift">
                    <div>
                      <img src="https://img.chatie.live/app/medal/images/ksa_no3.png" alt="" />
                    </div>
                    <p>Medal(Copper*1 year</p>
                  </div>

                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/headwear/ksa_no3.png" alt="" />
                    </div>
                    <p>Headwear*7 days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="https://img.chatie.live/app/mount/ksa_no3.png" alt="" />
                    </div>
                    <p>mount 7days</p>
                  </div>
                  <div className="item-gift">
                    <div>
                    <img src="/img/activity/recharge/gold.png" alt="" />
                    </div>
                    <p>3% of score</p>
                  </div>
                  </div>
              </div>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/Prize/index.js